/*
    For round-robin demo recommendations for each checkout page.

    message: text displayed on the checkout page after "Recommend" is clicked

    mode: denotes which checkout type the recommendation selects
        - for storco: must be either 'fiat' or 'points'
        - for belta: must be either 'fiat', 'coins', or 'miles'

    file: the name of the audio file the recommendation selection should play
        - use .mp3 file types
        - place any new files in the /frontend/public/static/audio folder
        - ** New audio files can be easily auto-generated at https://www.kukarella.com/text-to-voice-converter
*/

const recommendations = {
    storco: [
        {
            message: 'Pay with dollars because you are below a reward points level.',
            mode: 'fiat',
            file: 'storco_1.mp3'
        },
        {
            message: 'Pay with STOR Coins because you have enough.',
            mode: 'points',
            file: 'storco_2.mp3'
        },
        {
            message: 'Pay with dollars because your STOR points have declined.',
            mode: 'fiat',
            file: 'storco_3.mp3'
        }
    ],
    belta: [
        {
            message: 'Pay with dollars because you are below a reward points level.',
            mode: 'fiat',
            file: 'storco_1.mp3'
        },        {
            message: 'Pay with Belta Miles because you have enough.',
            mode: 'miles',
            file: 'belta_2.mp3'
        },        {
            message: 'Pay with BELTA Coins because you have enough and they will expire soon.',
            mode: 'coins',
            file: 'belta_3.mp3'
        },        {
            message: 'Pay with dollars because your loyalty points have declined.',
            mode: 'fiat',
            file: 'belta_4.mp3'
        }
    ]
};

export default recommendations;
